import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import { confirmDelete, successToast, errorToast } from "../../../utils/dialog";

const AboutInfoAdmin = () => {
  const { aboutInfoData, updateAboutInfo, deleteAboutInfo } = useData();

  const [formData, setFormData] = useState({
    heading: aboutInfoData.heading || "",
    subheading: aboutInfoData.subheading || "",
    paragraphs: aboutInfoData.paragraphs || ["", ""],
    stats: aboutInfoData.stats || { guests: "", memories: "", nights: "" },
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleStatsChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      stats: { ...prev.stats, [name]: value },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateAboutInfo(formData);
      successToast("About Info section updated.");
    } catch (err) {
      console.error(err);
      errorToast("Error updating About Info section.");
    }
  };

  const handleDelete = async () => {
    if (
      await confirmDelete({
        title: "Delete section?",
        text: "This About Info section will be permanently removed.",
      })
    ) {
      try {
        await deleteAboutInfo();
        successToast("About Info section deleted.");
      } catch (err) {
        console.error(err);
        errorToast("Error deleting About Info section.");
      }
    }
  };

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">About Info Admin Panel</h2>

      {/* Form */}
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
        <h3 className="text-2xl font-semibold text-gray-700 mb-4">Update Section</h3>
        <input
          name="heading"
          value={formData.heading}
          onChange={handleInputChange}
          placeholder="Main Heading"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
        <input
          name="subheading"
          value={formData.subheading}
          onChange={handleInputChange}
          placeholder="Subheading"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
        <textarea
          name="paragraphs[0]"
          value={formData.paragraphs[0]}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              paragraphs: [e.target.value, prev.paragraphs[1]],
            }))
          }
          placeholder="First Paragraph"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
        <textarea
          name="paragraphs[1]"
          value={formData.paragraphs[1]}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              paragraphs: [prev.paragraphs[0], e.target.value],
            }))
          }
          placeholder="Second Paragraph"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Guests</label>
            <input
              name="guests"
              value={formData.stats.guests}
              onChange={handleStatsChange}
              placeholder="Guests"
              className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Memories</label>
            <input
              name="memories"
              value={formData.stats.memories}
              onChange={handleStatsChange}
              placeholder="Memories"
              className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Nights</label>
            <input
              name="nights"
              value={formData.stats.nights}
              onChange={handleStatsChange}
              placeholder="Nights"
              className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
            />
          </div>
        </div>

        <div className="flex justify-end space-x-4">
          <button
            type="submit"
            className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
          >
            Update Section
          </button>
          <button
            type="button"
            onClick={handleDelete}
            className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
          >
            Delete Section
          </button>
        </div>
      </form>
    </div>
  );
};

export default AboutInfoAdmin;